import { render, staticRenderFns } from "./BtnInserirItemContrato.vue?vue&type=template&id=46d0c6fe"
import script from "./BtnInserirItemContrato.vue?vue&type=script&lang=js"
export * from "./BtnInserirItemContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports